let Guid = require('../../math/guid');

/**
 * Класс, описывающий маршрутную точку
 */
class RoutingLocation {
    constructor(params) {
        this.id = params.id || Guid.createGUID();
        this.title = params.title || this.id;
        this.address = params.address;
        this.coordinate = params.coordinate;
    }
}

module.exports = RoutingLocation;